/* eslint-disable react-hooks/exhaustive-deps */
// disabled due to issues with Formik dependencies that caused inifinite loops
import React from 'react';
import { Configure } from 'react-instantsearch-dom';
import { Formik } from 'formik';

// Components
import NewConversationMemberSearchHit from './NewConversationMemberSearchHit';
import Autocomplete from '@molecules/Autocomplete';
import SearchContainer from '@search/SearchContainer';

const NewConversationMemberSearch = () => {
    const handleSubmit = () => {
        console.log('submit');
    };

    const handleSelect = option => {
        console.log({ option });
    };

    return (
        <Formik onSubmit={handleSubmit} enableReinitialize initialValues={{ query: '' }}>
            {formik => (
                <SearchContainer key="members-inbox-search-conversations" index="members">
                    <Configure hitsPerPage={100} filters={`status:"Active"`} />
                    <Autocomplete
                        name="query"
                        label="Start a new conversation"
                        compHit={NewConversationMemberSearchHit}
                        placeholder="Search for a member"
                        onSelect={handleSelect}
                    />
                </SearchContainer>
            )}
        </Formik>
    );
};

// InboxSearchConversations.propTypes = {
// };

export default NewConversationMemberSearch;
